export default __webpack_public_path__ + "static/cesp_1-59e49ea2ccdcfa96d698286c015a2052.png";